import { useEffect, useState } from "react"

import { Divider, Modal, Spin } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import CreateAlertTicketForm from "../../../../Components/Forms/CreateAlertTicketForm"
import Icon from "../../../../Icon"
import { createAlertTicket } from "../../redux/alerts.thunks"
import { OverviewInfo } from "../OverviewInfo"

export const CreateTicketModal = ({
  isDemo,
  externalDemoMode,
  showIcon = true,
  fullWidth = false
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const isMobile = useSelector((state) => state.nav.isMobile)
  const userInfo = useSelector((state) => state.auth.userInfo)
  const isAdmin = useSelector((state) => state.auth.isAdmin)
  const { alertDetails, saveFetching, saveResult } = useSelector((state) => state.alerts)
  const [open, setOpen] = useState(false)
  const isDemoModeBlocked = !userInfo.current_business_account_id && !isAdmin

  const handleCloseModal = () => {
    setOpen(false)
  }
  const handleSubmitForm = (values) => {
    const data = { ...values, alert_id: alertDetails?.alert_id }
    dispatch(createAlertTicket(data))
  }

  useEffect(() => {
    if (saveResult === "ticket_create") handleCloseModal()
  }, [saveResult])

  const fullData = {
    ...alertDetails,
    user_name: `${userInfo?.first_name} ${userInfo?.last_name || ""}`,
    user_email: userInfo?.email
  }

  return (
    <>
      <ButtonComponent
        onClick={() => setOpen(true)}
        icon={showIcon ? <Icon type="support_circle" /> : null}
        text={t("Contact support")}
        disabled={isDemo || externalDemoMode || isDemoModeBlocked}
        style={{ width: fullWidth && "100%" }}
      />
      <Modal
        {...(isMobile ? { transitionName: "" } : null)}
        getContainer={() => document.getElementById("main-layout")}
        closeIcon={<Icon type="cross_small" />}
        centered={!isMobile}
        open={open}
        width={442}
        title={t("Contact support")}
        footer={null}
        closable="true"
        onCancel={handleCloseModal}
        destroyOnClose
        classNames={{ content: "clear-bg" }}
      >
        <Spin size="large" spinning={saveFetching}>
          <OverviewInfo data={fullData} type="modalForm" />

          <Divider style={{ margin: "16px 0" }} />
          <CreateAlertTicketForm onSubmit={handleSubmitForm} onClose={handleCloseModal} />
        </Spin>
      </Modal>
    </>
  )
}
